<template>
  <v-parallax
    dark
    :src="require('@/assets/section/' + imgLink)"
    class="px-0"
    height="100vh"
  >
    <v-row align="center" justify="center" class="capa-gradiente px-0">
      <v-col class="text-center" cols="12">
        <!-- <h1 class="display-1 font-weight-light title-position">
          {{ title }}
        </h1> -->
        <vue-typed-js
          :strings="[title]"
          :loop="true"
          :showCursor="false"
          :typeSpeed="70"
          :loopCount="1"
        >
          <h1
            class="typing display-2 white--text font-weight-light title-position text-uppercase"
          ></h1>
        </vue-typed-js>
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
export default {
  name: "The-Hero-Section",
  props: {
    imgLink: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Argecam S.R.L."
    }
  },
  data: () => ({
    typedjs: {
      cursorChar: "&block;",
      showCursor: true,
      loop: true,
      startDelay: 0
    }
  })
};
</script>

<style scoped>
.title-position {
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
}
.capa-gradiente {
  width: 100vw;
  height: 100vh;
  margin: 0;
  background-image: linear-gradient(
    to bottom,
    rgba(37, 48, 63, 0.1),
    rgba(33, 44, 59, 0.25),
    rgba(30, 39, 54, 0.5),
    rgba(26, 35, 50, 0.75),
    rgba(23, 31, 46, 1),
    #171f2e
  );
}
</style>
